export default "__VITE_ASSET__C_qN2T06__"